import ApiClient from '@/helpers/api/api.helpers';

class ChatApi extends ApiClient {
  constructor() {
    super('iam/workspaces/chat-contact');
  }
}

export default new ChatApi();
